import React, { useState, useEffect, useContext } from 'react';
import './TagSearchInput.css';
import { ExploreContext } from '../../Context/ExploreContext';
import { TagDeny } from '../../interface';
interface TagSearchInputProps {
  selectedTags: TagDeny[];
  onTagsChange: (tags: TagDeny[]) => void;
}

const TagSearchInput: React.FC<TagSearchInputProps> = ({ selectedTags, onTagsChange }) => {
  const { searchAccounts } = useContext(ExploreContext);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredTags, setFilteredTags] = useState<TagDeny[]>([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (searchTerm.length < 2) {
      setFilteredTags([]);
      setShowDropdown(false);
      return;
    }

    const fetchTags = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await searchAccounts(searchTerm);

        if (response.success && Array.isArray(response.accounts)) {
          const formattedResults = response.accounts.map((acc: any) => ({
            id: acc.id,
            name: acc.institution_name,
          }));

          setFilteredTags(
            formattedResults.filter((tag: { id: number; }) => !selectedTags.some(selected => selected.id === tag.id))
          );

          setShowDropdown(formattedResults.length > 0);
        }
      } catch (err) {
        console.error("Error fetching tags:", err);
        setError("Failed to load institutions");
      } finally {
        setLoading(false);
      }
    };

    const debounceTimeout = setTimeout(() => {
      fetchTags();
    }, 300);

    return () => clearTimeout(debounceTimeout);
  }, [searchTerm, selectedTags]);

  const handleTagSelect = (tag: TagDeny) => {
    if (!selectedTags.some(selected => selected.id === tag.id)) {
      onTagsChange([...selectedTags, tag]); // ✅ Guarda objeto { id, name }
    }
    setSearchTerm('');
    setFilteredTags([]);
    setShowDropdown(false);
  };

  return (
    <div className="tag-search-container">
      <div className="selected-tags">
        {selectedTags.map(tag => (
          <span key={tag.id} className="tag-badge">
            {tag.name}
            <button
              type="button"
              className="remove-tag-btn"
              onClick={() => onTagsChange(selectedTags.filter(t => t.id !== tag.id))}
              aria-label={`Remove ${tag.name}`}
            >
              &times;
            </button>
          </span>
        ))}

      </div>
      <input
        type="text"
        className="tag-input-field"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        onFocus={() => setShowDropdown(true)}
        placeholder="Search institution..."
      />

      {showDropdown && (
        <ul className="tag-suggestions">
          {loading ? (
            <li className="loading-message">Loading...</li>
          ) : error ? (
            <li className="error-message">{error}</li>
          ) : (
            filteredTags.map(tag => (
              <li key={tag.id} onClick={() => handleTagSelect(tag)} className="tag-suggestion-item">
                {tag.name}
              </li>
            ))
          )}
        </ul>
      )}
    </div>
  );
};

export default TagSearchInput;
